import React, { useState, useRef } from "react";
import Header from "./Header/Header";
import ElasticSearch from "./Search/Elasticsearch";
import Content from "./Content/Content";
import Footer from "./Footer/Footer";
import { Tooltip } from "react-tooltip";

export default function Layout() {
  const [isChecked, setIsChecked] = useState(false);
  const [payeeName, setPayeeName] = React.useState('');
  const [address2, setAddress2] = React.useState('');
  const [payerSource, setPayerSource] = React.useState('');

  var searchRef = useRef();
  var payeeNameRef = useRef();
  var payeeSuburbRef = useRef();

  const validateFields = () => {
    if (payeeName !== null && payeeName !== "" && address2 !== null & address2 !== "") {
      payeeNameRef.current.style.display = "none";
      payeeSuburbRef.current.style.display = "none";
      runSearch();
    }
    
    if (payeeName === null || payeeName === "") {
      payeeNameRef.current.style.display = "block";
    }
    else{
      payeeNameRef.current.style.display = "none";
    }

    if (address2 === null || address2 === "") {
      payeeSuburbRef.current.style.display = "block";
    }
    else{
      payeeSuburbRef.current.style.display = "none";
    }
  }

  const runSearch = () => {
    searchRef.current.performSearch(1);
  }

  const clearSearch = () => {
    setPayeeName('');
    setAddress2('');
    setPayerSource('');
    searchRef.current.clearSearch();
  }
  const handleKeypress = (e) => {
    if (e.key === 'Enter') {
      validateFields();
    }
  }


  return (
    <div className="layout">
      <Header />
      <Content isChecked={isChecked} setIsChecked={setIsChecked} />
      <div className="search">
        <div className="container">
          <div className="input-section">
            <div className="inputs">
              <div className="input-box">
                <div className="input-title">
                  <div>
                    <label htmlFor="payeeName">Payee name</label>
                    <span className="text-lighter">(mandatory)</span>
                  </div>
                </div>
                <div>
                  <input
                    onKeyUp={handleKeypress}
                    className="form-control"
                    disabled={!isChecked}
                    id="payeeName"
                    type="text"
                    value={payeeName}
                    onChange={(e) => setPayeeName(e.target.value)}
                  />
                </div>
              </div>

              <div className="input-box">
                <div className="input-title">
                  <div>
                    <label htmlFor="suberName">Payee suburb/postcode</label>
                    <span className="text-lighter">(mandatory)</span>
                  </div>
                  <div className="anchor1" tabIndex="0">i</div>
                  <Tooltip
                    anchorSelect=".anchor1"
                    place="top"
                    style={{
                      width: "130px",
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    Try your current suburb and any old suburbs you may have lived in or been associated with 
                    - which could also include a post office box or business address. You can also try using a postcode.
                  </Tooltip>
                </div>
                <div>
                  <input
                    onKeyUp={handleKeypress}
                    className="form-control"
                    disabled={!isChecked}
                    id="address_2"
                    type="text"
                    value={address2}
                    onChange={(e) => setAddress2(e.target.value)}
                  />
                </div>
              </div>

              <div className="input-box">
                <div className="input-title">
                  <div>
                    <label htmlFor="paymentOrganisationName">
                      Payment organisation name
                    </label>
                    <span className="text-lighter">(optional)</span>
                  </div>
                  <div className="anchor2" tabIndex="0">i</div>
                  <Tooltip
                    anchorSelect=".anchor2"
                    place="top"
                    style={{
                      width: "140px",
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    Enter the name of the organisation that made the original payment.
                  </Tooltip>
                </div>
                <div>
                  <input
                    onKeyUp={handleKeypress}
                    className="form-control"
                    disabled={!isChecked}
                    id="source"
                    type="text"
                    value={payerSource}
                    onChange={(e) => setPayerSource(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="btns">
              <button
                className="search-btn"
                type="submit"
                onClick={validateFields}
                disabled={!isChecked}
              >
                Search
              </button>
              <button onClick={clearSearch} disabled={!isChecked}>
                Clear
              </button>
            </div>
          </div>
          <div className="results-summary" aria-live="polite">
            <p ref={payeeNameRef} style={{display: "none"}}>Payee name is required.</p>
            <p ref={payeeSuburbRef} style={{display: "none"}}>Payee suburb is required.</p>
          </div>
          <ElasticSearch payeeName={payeeName} payerSource={payerSource} address2={address2} ref={searchRef} pageSize={10} />
        </div>
      </div>
      <Footer />
    </div>
  );
}
